import { IOptionStringOrNumberValue, IOptionStringValue } from 'bricks/types';
import { IDocumentLibraryReportAsset } from './NewCombinedReportSection/DocumentLibraryCard/types';

 
export enum ActiveSections {
    INITIAL = 'Initial',
    START_NEW_REPORT = 'Start New Report',
    SELECT_SAVED_TEMPLATE = 'Select Saved Template',
}

export enum ReportTypes {
    SAVED_REPORT = 'saved_report',
    BACK_OF_ENVELOPE_SCENARIO_COMPARISON = 'back_of_envelope_scenario_comparison',
    DEAL_BACK_OF_EVENLOPE = 'deal_back_of_envelope',
    DEAL_OVERVIEW = 'deal_overview',
    DOCUMENT_LIBRARY = 'document_library',
    PRO_FORMA_EXECUTIVE_SUMMARY = 'pro_forma_executive_summary',
}

export const NEW_REPORT_LABELS = {
    BACK_OF_ENVELOPE_SCENARIO_COMPARISON: 'Back-of-Envelope Scenario Comparison',
    DEAL_BACK_OF_EVENLOPE: 'Deal Back-Of-Envelope',
    DEAL_OVERVIEW: 'Deal Overview',
    DOCUMENT_LIBRARY: 'Document Library',
    PRO_FORMA_EXECUTIVE_SUMMARY: 'Pro Forma Executive Summary',
};

export const REPORT_TYPE_LABEL_MAP: Record<string, string> = {
    [ReportTypes.BACK_OF_ENVELOPE_SCENARIO_COMPARISON]: NEW_REPORT_LABELS.BACK_OF_ENVELOPE_SCENARIO_COMPARISON,
    [ReportTypes.DEAL_BACK_OF_EVENLOPE]: NEW_REPORT_LABELS.DEAL_BACK_OF_EVENLOPE,
    [ReportTypes.DEAL_OVERVIEW]: NEW_REPORT_LABELS.DEAL_OVERVIEW,
    [ReportTypes.DOCUMENT_LIBRARY]: NEW_REPORT_LABELS.DOCUMENT_LIBRARY,
    [ReportTypes.PRO_FORMA_EXECUTIVE_SUMMARY]: NEW_REPORT_LABELS.PRO_FORMA_EXECUTIVE_SUMMARY,
};

export const REPORT_CLASSNAME_MAP: Record<string, string> = {
    [ReportTypes.BACK_OF_ENVELOPE_SCENARIO_COMPARISON]: 'heap-deal-report-builder-add-back-of-envelope-scenario-comparison',
    [ReportTypes.DEAL_BACK_OF_EVENLOPE]: 'heap-deal-report-builder-add-deal-back-of-envelope',
    [ReportTypes.DEAL_OVERVIEW]: 'heap-deal-report-builder-add-deal-overview',
    [ReportTypes.DOCUMENT_LIBRARY]: 'heap-deal-report-builder-add-document-library',
    [ReportTypes.PRO_FORMA_EXECUTIVE_SUMMARY]: 'heap-deal-report-builder-add-pro-forma-executive-summary',
};

export interface IReportBuilderReport {
    savedReportId?: number;
    savedReportName?: string;
    savedReportType?: string;
    reportType: string;
    selectedBOEScenarioIds?: Array<number>;
    selectedBOEScenarioNames?: Array<string>;
    selectedDealAttributes?: Array<{ name: string; correlationId: string }>
    selectedProFormaId?: number;
    selectedProFormaName?: string;
    includePrintedOnDate?: boolean;
    includeTargetReturns?: boolean;
    isEditing?: boolean;
    metaData?: any;

    selectedFolders?: Array<IOptionStringOrNumberValue>;
    selectedDocumentTypes?: Array<IOptionStringValue>;
    selectAllFolders?: boolean;
    selectedDocuments?: Array<IDocumentLibraryReportAsset>;
}

export const DEAL_OVERVIEW_ATTRIBUTES: Record<'general' | 'dealInformation' | 'dealMetrics' | 'personnel' | 'capitalPartners' | 'vendors', string[]> = {
    general: ['Deal name', 'Address', 'Market', 'Submarket', 'Date created', 'Description'],
    dealInformation: [
        'Deal type',
        'Asset class',
        'Construction type',
        'Units: Gross SF',
        'Units: Rentable SF',
        'Units: Finished SF',
        'Units: Acres',
        'Units: Residential units',
        'Units: Beds',
        'Units: Lots',
        'Phase',
        'Lead source',
        'Leasing strategy',
        'Rank',
    ],
    dealMetrics: ['Acquisition price', 'Target return on cost', 'Target return on equity', 'Target profit return', 'IRR', 'Equity multiple'],
    personnel: ['Deal creator', 'Deal owner', 'Development manager'],
    capitalPartners: ['Equity partner', 'Lender'],
    vendors: ['Legal counsel', 'Architect', 'Engineer', 'Surveyor', 'Environmental consultant'],
};

export const DEAL_OVERVIEW_ATTRIBUTES_TO_DEAL_PROPS: Record<string, string> = {
    'Deal creator': 'Creator name',
};

export const DEAL_PROPS_TO_DEAL_OVERVIEW_ATTRIBUTES: Record<string, string> = Object.fromEntries(
    Object.entries(DEAL_OVERVIEW_ATTRIBUTES_TO_DEAL_PROPS).map(([k, v]) => [v, k]),
);

export const savedReportTypeMap: Record<number, string> = {
    1: 'Pipeline report',
    2: 'Comparison report',
    3: 'Combined deal report',
};
